import { render, staticRenderFns } from "./StoreVendorsMap.vue?vue&type=template&id=4d0e55b5&scoped=true&"
import script from "./StoreVendorsMap.vue?vue&type=script&lang=js&"
export * from "./StoreVendorsMap.vue?vue&type=script&lang=js&"
import style0 from "./StoreVendorsMap.vue?vue&type=style&index=0&id=4d0e55b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0e55b5",
  null
  
)

export default component.exports